import React, { type ReactElement } from 'react';
import { Typography } from 'antd';
import { LockOutlined } from '@ant-design/icons';

// Add an entry here when a page becomes restricted in a new way, so the
// wording stays identical everywhere it is shown.
const MESSAGES = {
  admin: 'Admin only — not visible to other users',
} as const;

type AccessLevel = keyof typeof MESSAGES;

export default function AccessNotice({ level }: { level: AccessLevel }): ReactElement {
  return (
    <Typography.Text type="secondary" style={{ display: 'block', marginBottom: 16, fontSize: 12 }}>
      <LockOutlined style={{ marginRight: 6 }} />
      {MESSAGES[level]}
    </Typography.Text>
  );
}
